module.exports = "<div class=\"layout-column layout-padding\"><date-time-picker class=\"flex\" [fg]=\"fg\" field=\"from\" placeholder=\"From\" [alt]=\"true\" format=\"MM/DD/YYYY\" [required]=\"true\"></date-time-picker><date-time-picker class=\"flex\" [fg]=\"fg\" field=\"to\" placeholder=\"To\" [alt]=\"true\" format=\"MM/DD/YYYY\" [required]=\"true\"></date-time-picker></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/date-range/date-range.component.pug
// module id = 266
// module chunks = 0